











































































































































import Vue from 'vue';
import { IMenuItem, IOpenItem } from '@/types/common';
import { mapGetters } from 'vuex';
import { HOME } from '@/constants/label';
import Loading from './Loading.vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  components: {
    Loading,
  },
  name: 'App',
  data: () => ({
    loading: true,
    drawer: true,
    active: [] as IMenuItem[], // どのノードをアクティブにするかをコントロールできる同期的なプロパティ
    initialOpen: [] as IOpenItem[], // どのノードが開かれているかを制御するためのSyncable prop
    title: '',
    helpUrl: '',
    hikisuInfo: '',
    soshikiMei: '',
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
      menu: 'common/menu',
      headerInfo: 'common/headerInfo',
      changePassswordRequired: 'common/changePassswordRequired',
    }),
    isHome(): boolean {
      const programId = sessionStorage.getItem('ProgramId');
      return programId === 'Home';
    },
    menuHeight() {
      return this.$vuetify.breakpoint.height - 170;
    },
  },
  watch: {
    userInfo() {
      this.soshikiMei =
        this.userInfo.soshikiData !== undefined &&
        this.userInfo.soshikiData !== null &&
        this.userInfo.soshikiData.soshikiMei !== undefined &&
        this.userInfo.soshikiData.soshikiMei !== null
          ? this.userInfo.soshikiData.soshikiMei
          : '';
    },
    //URL 手入力した際に、該当の menu data を active にする
    active(arr) {
      // 画面遷移する
      if (arr.length) this.transition(arr[0]);
    },
    // mounted で menu data 所得した際に発火
    menu(menuList) {
      // treeview の menu 選択処理を行う
      //    この場合は [/home] を選択
      this.findMenuItemActive(menuList);

      // me で取得した data が [要 password change] の場合、[パスワード変更画面] に遷移する
      if (this.changePassswordRequired) {
        this.$router.push({ name: 'ChangePassword' });
      }

      // 読み込み終了なので、画面の表示を開始する
      this.loading = false;

      // store に title と help url を保持する
      //    画面 header 部の title と help url は、store と連動している
      if (this.title) {
        this.$store.dispatch('common/setHeaderInfo', {
          title: this.title,
          helpUrl: this.helpUrl,
          hikisuInfo: this.hikisuInfo,
        });
      }
    },
  },
  methods: {
    // 画面遷移する(treeview click、手入力 どちらからも呼ばれる)
    transition(item: IMenuItem) {
      this.title = item.title;
      this.helpUrl = item.helpUrl ? item.helpUrl : '';
      this.hikisuInfo = item.hikisuInfo ? item.hikisuInfo : '';

      // store に title と help url を保持する
      //    画面 header 部の title と help url は、store と連動している
      this.$store.dispatch('common/setHeaderInfo', {
        title: this.title,
        helpUrl: this.helpUrl,
        hikisuInfo: this.hikisuInfo,
      });
      if (item.to) {
        // store の message を reset する
        this.$store.dispatch('common/resetMessage');

        // menu data の to に遷移する
        this.$router.push(item.to, () => {});
      }
    },
    // mounted 直後及び、URL 手入力した際に、treeview の menu 選択処理を行う
    //    mounted 直後の path(URL) は、[index.ts] の下記設定により、[/home] となる
    //      const routes: Array<RouteConfig> = [
    //      {
    //        path: '/',
    //        component: Layout,
    //        redirect: '/home',
    //        children: appRoutes.concat(sampleRoutes),
    //      },
    findMenuItemActive(menuList: IMenuItem[]) {
      // login 時に取得した menu data を loop
      menuList.forEach((menuItem: IMenuItem) => {
        if (menuItem.children) {
          this.findMenuItemActive(menuItem.children);
        } else {
          // 手入力した URL と同じ URL の menu data を探す
          if (this.$route.path === `/${menuItem.to}`) {
            // 該当の menu data を active にする
            this.active = [menuItem];
            // 画面 title を保持する
            this.title = menuItem.title;
            // help url を保持する
            this.helpUrl = menuItem.helpUrl ? menuItem.helpUrl : '';
            if (menuItem.expand) {
              // treeview を開いて選択状態にする
              this.initialOpen = menuItem.expand.map((id: number) => {
                return { id };
              });
            }
          }
        }
      });
    },
    // [HOME] click
    handleHome(): void {
      // title 会内 : 加工食品情報システム、会外 : ホクレン受発注システム
      this.title = this.userInfo.kainaiKaigaiKb
        ? HOME.HEADER_TITLE_KAIGAI
        : HOME.HEADER_TITLE_KAINAI;

      // store に title と help url を保持する
      //    画面 header 部の title と help url は、store と連動している
      this.$store.dispatch('common/setHeaderInfo', {
        title: this.title,
        helpUrl: '',
      });
      this.active = [];
      this.initialOpen = [];
    },
    handleLogout(): void {
      this.$store.dispatch('common/logout');
    },
    handleHelp(): void {
      if (this.helpUrl !== '') {
        window.open(this.headerInfo.helpUrl, '_blank');
      } else {
        //HOME画面 で help click した場合、環境変数で設定した URL を開く
        window.open(process.env.VUE_APP_HOME_HELP_URL, '_blank');
      }
    },
  },
  mounted() {
    this.$store.dispatch('common/getMe');
  },
});
